import React from 'react'
import { connect } from 'react-redux'

import {
  toggleMenu
} from '../store/actions/menuAction'
import {
  setPlaylistOrder
} from '../store/actions/playerAction'

import MenuPlaylists from './menu/MenuPlaylists'
import MenuClasses from './menu/MenuClasses'

import Icon from '../ui/Icon'

class Menu extends React.Component{

  constructor(props){
    super(props)
    this.state = {
      type:'classes',
      order:'shuffle'
    }
  }

  closeMenu(){
    this.props.dispatch(toggleMenu(false))
  }

  selectType(type){
    this.setState({type:type})
  }

  selectOrder(order){
    this.setState({order:order})
    this.props.dispatch(setPlaylistOrder(order))
  }

  getView(){
    switch(this.state.type){
      case 'playlists':
        return <MenuPlaylists/>
      case 'classes':
        return <MenuClasses/>
    }
  }

  render(){
    const {
      type,
      order
    } = this.state
    return (
      <div className={`menu ${this.props.isActive && 'active'}`}>
        <div className="menu-header">
          <div className="button-menu">
            <div 
              onClick={() => this.selectType('classes')}
              className={`button-menu-item ${type === 'classes' && 'active'}`}>
              Classes
            </div>
            <div 
              onClick={() => this.selectType('playlists')}
              className={`button-menu-item ${type === 'playlists' && 'active'}`}>
              Playlists
            </div>
          </div>
          <Icon name="close" action={() => this.closeMenu()}/>
        </div>
        <div className="menu-view-wrapper">
          {this.getView()}
        </div>
        <div className="menu-footer">
          <div className="button-menu-bottom">
            <div 
              onClick={() => this.selectOrder('shuffle')}
              className={`button-menu-item ${order === 'shuffle' && 'active'}`}>
              Shuffle
            </div>
            <div 
              onClick={() => this.selectOrder('ordered')}
              className={`button-menu-item ${order === 'ordered' && 'active'}`}>
              Ordered
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(store){
  return {
    overlay:store.overlay,
    loading:store.overlay.loading
  }
}

export default connect(mapStateToProps)(Menu)


// WEBPACK FOOTER //
// ./src/components/Menu.js